import * as React from 'react'
import { useEffect, useState, useRef } from 'react'
import { Tooltip } from 'antd'

import { EditIcon, EnterIcon } from '../icons'

import styles from './styles.module.less'

export interface EditableLabelProps {
    canEdit: boolean
    editClassName?: string
    editOnClick: boolean
    editStyle?: React.CSSProperties
    focusOnMount?: boolean
    htmlTag: any
    initialValue: string
    labelClassName?: string
    labelStyle?: React.CSSProperties
    onBeforeEdit?: () => null
    onSave: (savedValue: string) => string | void
    setCursorOnFocus?: 'endOfSelection' | 'selectAll'
    stopCancelPropagation?: boolean
    stopEnterPropagation?: boolean
}

export interface EditableLabelState {
    editing: boolean
}

export const EditableLabel: React.FC<EditableLabelProps> = (props) => {
    const { setCursorOnFocus } = props
    const [value, setValue] = useState(props.initialValue)
    const [editing, setEditing] = useState(false)
    const [saving, setSaving] = useState(false)
    const [cancelChange, setCancelChange] = useState(false)
    const focusOnMount =
        props.focusOnMount !== undefined ? props.focusOnMount : false
    const stopCancelPropagation =
        props.stopCancelPropagation !== undefined
            ? props.stopCancelPropagation
            : true
    const stopEnterPropagation =
        props.stopEnterPropagation !== undefined
            ? props.stopEnterPropagation
            : true

    const domElm: React.RefObject<HTMLSelectElement> = useRef(null)

    useEffect(() => {
        if (focusOnMount) {
            edit()
        }
    }, [])

    useEffect(() => {
        setValue(props.initialValue)
    }, [props.initialValue])
    useEffect(() => {
        if (domElm?.current) {
            domElm.current.focus()
            if (isValueChanged() && !editing && !cancelChange) {
                const val = domElm.current?.textContent?.toString().trim()
                if (val) {
                    setValue(val)
                    props.onSave(val)
                    setSaving(false)
                }
            } else {
                domElm.current.textContent = props.initialValue
                setCancelChange(false)
                return
            }
        }
    }, [editing])

    const toggleEdit = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation()
        props.onBeforeEdit && props.onBeforeEdit()
        if (!editing) {
            edit()
        }
    }

    const onFocus = (e: any) => {
        //console.log(domElm)
        //domElm.current.
    }

    function placeCaretAtEnd(el: any) {
        el.focus()
        if (
            typeof window.getSelection != 'undefined' &&
            typeof document.createRange != 'undefined'
        ) {
            var range = document.createRange()
            range.selectNodeContents(el)
            range.collapse(false)
            var sel = window.getSelection()
            if (sel) {
                sel.removeAllRanges()
                sel.addRange(range)
            }
        } else if (
            typeof (document.body as any).createTextRange != 'undefined'
        ) {
            var textRange = (document.body as any).createTextRange()
            textRange.moveToElementText(el)
            textRange.collapse(false)
            textRange.select()
        }
    }

    const selectElementContents = (el: any) => {
        var range = document.createRange()
        range.selectNodeContents(el)
        var sel = window.getSelection()
        if (sel) {
            sel.removeAllRanges()
            sel.addRange(range)
        }
    }

    const edit = () => {
        setEditing(true)
        if (setCursorOnFocus !== undefined) {
            if (domElm.current) {
            }
        }
    }

    const save = () => {
        setEditing(false)
        setSaving(true)
    }

    const cancel = () => {
        setCancelChange(true)
        setEditing(false)
    }

    const isValueChanged = () => {
        return (
            value.toString().trim() !==
            domElm?.current?.textContent?.toString().trim()
        )
        // return props.initialValue !== domElm.current.textContent
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        const { key } = e
        switch (key) {
            case 'Enter':
                save()
                if (stopEnterPropagation) {
                    e.stopPropagation()
                    e.nativeEvent.stopImmediatePropagation()
                }
                break
            case 'Escape':
                cancel()
                if (stopCancelPropagation) {
                    e.stopPropagation()
                    e.nativeEvent.stopImmediatePropagation()
                }
                break
        }
    }

    let editOnClick = true

    if (props.editOnClick !== undefined) {
        editOnClick = props.editOnClick
    }

    if (props.initialValue.trim() === '') {
        editOnClick = false
    }

    const editableLabelClassName = editing
        ? styles.editableLabelWriteMode
        : styles.editableLabelReadMode

    const editClassName: any =
        props.editClassName === undefined ? styles.edit : props.editClassName
    const editDisabledClassName: any =
        props.labelClassName === undefined
            ? editOnClick
                ? styles.editDisabledInline
                : styles.editDisabled
            : props.labelClassName

    const editIcon = editing ? (
        <EnterIcon className={styles.editIcon} onClick={save} />
    ) : (
        <Tooltip title={'Click to edit'}>
            <EditIcon className={styles.editIcon} onClick={toggleEdit} />
        </Tooltip>
    )

    const onBlur = () => {
        window.setTimeout(() => {
            !saving && cancel()
        }, 100)
    }

    return (
        <span className={editableLabelClassName}>
            <props.htmlTag
                className={editing ? editClassName : editDisabledClassName}
                style={editing ? props.editStyle : props.labelStyle}
                suppressContentEditableWarning={true}
                contentEditable={editing}
                ref={domElm}
                onBlur={editOnClick ? save : onBlur}
                onKeyDown={handleKeyDown}
                onFocus={onFocus}
                onClick={editOnClick ? toggleEdit : undefined}
            >
                {value}
            </props.htmlTag>
            {!editOnClick && editIcon}
        </span>
    )
}
